<div class="copyright text-center" *ngIf="!isApp">
    <div class="text-small">
        <div class="mb-1">版权声明：如果来函说明本网站提供内容本人或法人版权所有。本网站在核实后，有权先行撤除，以保护版权拥有者的权益。</div>
        <span>邮箱地址：</span>
        <a href="mailto:info@{{host}}">info@{{host}}</a>
        <span style="margin-left: 1em;">地址：
            <span class="address-color">{{copyRight}}</span>
        </span>
        <div style="margin-top: 0.5em;"><b> {{host}}</b> 版权所有，未经授权禁止链接、复制或建立</div>
        <!-- <br /> Copyright 2010-2020 {{host}} Allrights Reserved. -->
        <div class="footer-copyright">Copyright 2021-2030 {{host}} All rights Reserved.</div>
    </div>
</div>
